import {svgIconWrapper} from '../svg-icon-wrapper';

import ApolloRegular from './apollo-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <ApolloRegular {...props} />;
}

SvgComponent.iconName = 'apolloRegular';

export const ApolloRegularIcon = svgIconWrapper(SvgComponent);
